<!-- 省厅端-首页样式 -->
<template>
    <div>
        <el-image :src="require('@/assets/img/index_bg.jpg')" fit="contain"></el-image>
    </div>
</template>

<script>
export default {
    data() {
        return {

            hash: '',
        }
    },
    mounted() {
    },
    computed: {
        headers() {
            return {
                "token": localStorage.getItem("token")// 图片上传获取token
            }
        }
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/homePage/defaultPage.vue